import React from "react";
import { useTranslation } from "locales";
import BaseButton from "components/BaseButton";
import BaseIcon from "components/BaseIcon";
import "./style.scss";

export default function BlockUniversityWorkshops() {
  const { t } = useTranslation();

  const cards = [
    {
      title: t("Pathway-Tailored"),
      description: t(
        "Cohort sessions shaped around the routes students target - investment banking, capital markets, buy side, and risk."
      ),
      icon: "git-branch",
    },
    {
      title: t("Practitioner-Led"),
      description: t(
        "Designed and delivered by coaches from the world's leading firms, on-site or fully virtual to suit your cohort."
      ),
      icon: "users",
    },
    {
      title: t("Complementary"),
      description: t(
        "Built to strengthen and extend your existing careers provision - never to replace the support already in place."
      ),
      icon: "layers",
    },
  ];

  return (
    <div className="block-university-workshops d-flex __column __align-center">
      <h2 className="block-university-workshops__title h1 mb-4 text-center mx-auto mt-10">
        {t("University Workshops")}
      </h2>
      <div className="block-university-workshops__description subtitle-1 text-neutral-darken-1 mb-10 text-center mx-auto">
        {t("Practitioner-led cohort sessions for MSc Finance and MBA programmes.")}
      </div>
      <div className="block-university-workshops__card-wrapper d-flex __wrap __justify-center">
        {cards.map((card, index) => (
          <div
            key={index}
            className="block-university-workshops__card box-shadow d-flex __column __align-center pa-6 text-center"
          >
            <div className="block-university-workshops__card-icon d-center mb-3">
              <BaseIcon size={32}>{card.icon}</BaseIcon>
            </div>
            <div className="caption-1 fw-bold mb-1">{card.title}</div>
            <div className="body-2 text-neutral-darken-1">{card.description}</div>
          </div>
        ))}
      </div>
      <BaseButton
        className="block-university-workshops__btn mt-10 body-1 fw-bold pl-4 pr-3"
        to={"/who-we-help?universities=1"}
        large
        dark
      >
        <span className="block-university-workshops__btn-text __mobile">{t("Partner with STO")}</span>
        <span className="block-university-workshops__btn-text __desktop">{t("Partner with Secure the Offer")}</span>
        <BaseIcon className="f-shrink-0 ml-2">chevron-right</BaseIcon>
      </BaseButton>
    </div>
  );
}
